module.exports = __webpack_public_path__ + "static/media/knearcontent.704818d6.png";